var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBmoBank = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#0078C1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9966 9C15.7176 9 9 15.7167 9 24.0005C9 32.2824 15.7176 39 23.9966 39C32.2843 39 38.999 32.2824 38.999 24.0005C38.999 15.7167 32.2853 9 23.9966 9Z",
    fill: "#ED1C24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8615 26.0432H31.0331V30.5173H16.8615V26.0432Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4866 19.357C23.6717 19.5933 23.8292 19.6632 23.9956 19.6661C24.1649 19.6622 24.3145 19.6031 24.4996 19.357C24.4996 19.357 26.8671 16.2453 26.9911 16.0956C27.3111 15.6979 27.697 15.6979 28.0169 16.0937L31.0341 19.9142V26.0441L28.0376 22.1961C27.6861 21.755 27.2845 21.7531 26.9301 22.1961C26.811 22.3516 24.5104 25.3983 24.5104 25.3983C24.1531 25.8502 23.8095 25.8502 23.4561 25.3983C23.4561 25.3983 21.1004 22.3358 20.9951 22.1961C20.6515 21.7619 20.2666 21.7531 19.8925 22.1961L16.8625 26.0441L16.8605 19.9329C16.8605 19.9329 19.7478 16.3132 19.9319 16.0947C20.2577 15.6989 20.6505 15.6989 20.9714 16.0917L23.4866 19.357Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBmoBank, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bmo_bank.88ea7d14.svg";
export { ForwardRef as ReactComponent };